export const queueItemsConstants = {
  QUEUEITEMS_REQUEST: 'QUEUEITEMS_REQUEST',
  QUEUEITEMS_SUCCESS: 'QUEUEITEMS_SUCCESS',
  QUEUEITEMS_FAILURE: 'QUEUEITEMS_FAILURE',
};
